import { Injectable } from '@angular/core';

@Injectable()
export class SupportService {
  initScheduleSupport(): void {
    window.open('https://calendly.com/d/5fd-5rs-7h6/simplidivine');
  }
}
